import { getAllReceptorTemplatesFiltered } from 'src/Utils/Receptors/getAllReceptorTemplatesFiltered'
import { RECEPTOR_TYPE } from '@trustero/trustero-api-web/lib/agent/receptor_pb'
import { Receptor } from 'src/xgenerated'
import { DropdownItemType } from './FilterDropdown.constants'

export const getReceptorFilterValues = (
  type: RECEPTOR_TYPE,
): DropdownItemType[] => {
  const receptors = getAllReceptorTemplatesFiltered(type).sort((a, b) =>
    a.name.localeCompare(b.name),
  )
  return receptors.map((receptor: Receptor) => ({
    value: receptor.modelid,
    label: receptor.name,
  }))
}
